<template>
  <div class="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100 p-4">
    <div v-if="hydrated">
      <NuxtRouteAnnouncer />
      <UContainer>
        <NuxtPage />
      </UContainer>
    </div>
    <div v-else>
      <NuxtIcon class="mdi:toolbox" />
    </div>
  </div>
</template>
<script setup lang="ts">
const hydrated = ref(false)
onMounted(() => {
  hydrated.value = true;
})
</script>
